import React from "react";
import {AutoSizer, Grid} from "react-virtualized";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import WizardFilterItem from "./wizardFilterItem";

const WizardDesktopGrid = (props) => {

  const {selectionWindowView, filterGroupValues, filterGroup, listItemHeight} = props;

  const elements = [];
  for (let i = 0; i < filterGroupValues.length; i++ ) {
    elements.push(<WizardFilterItem currentFilterValue={filterGroupValues[i]}
                                    listItemHeight={listItemHeight}
                                    filterGroup={filterGroup}/>);
  }

  const columnCount = selectionWindowView + 2; // for ex. 1,2,3 view -> 3,4,5 columns

  const list = [[]];  // making list for React Virtualized
  let columnIndex = 0;
  elements.forEach((element, index) => {
    if (index % columnCount === 0 && (index !== 0)) {
      list.push([]);
      columnIndex++;
    }
    list[columnIndex].push(React.cloneElement(element))
  });

  return (
    <AutoSizer>
      {({width, height}) => (
        <Grid rowCount={Math.ceil(elements.length / columnCount)}
              columnCount={columnCount}
              width={width}
              height={height}
              columnWidth={(width / columnCount) - 2}
              rowHeight={listItemHeight + 5}
              cellRenderer={({columnIndex, key, rowIndex, style}) => {
                return <div key={key} style={style}>
                  {list[rowIndex][columnIndex]}
                </div>
              }}>
        </Grid>
      )}
    </AutoSizer>
  )

}

WizardDesktopGrid.propTypes = {
  currentParent: PropTypes.object.isRequired,
  filterGroupValues: PropTypes.array.isRequired,
  filterGroup: PropTypes.object.isRequired,
  currentActiveFilters: PropTypes.object.isRequired,
  listItemHeight: PropTypes.number,
}

const mapStateToProps = (store) => {
  const {selectionWindowView} = store.selectionState;
  return {
    selectionWindowView,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(WizardDesktopGrid)
